<template>
  <div class="hl-overlay" @click.self="$emit('close')">
    <div class="hl-confirm-card">
      <button
        type="button"
        class="hl-close hl-close--outline"
        @click="$emit('close')"
      >
        &times;
      </button>

      <h3 class="hl-confirm-title">{{ title }}</h3>
      <slot />

      <div class="hl-confirm-actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
// Generic confirmation dialog for the Event Highlights feature
// (download / redownload / delete). Caller provides the body (default slot)
// and the buttons (#actions slot); chrome + styling are shared.
import "@/assets/css/event-highlights.css";

export default {
  name: "HighlightDialog",
  props: {
    title: { type: String, required: true },
  },
  emits: ["close"],
};
</script>
